import React from "react";
import { AppContext } from "../../core/ApplicationContextProvider";
import Contact from "../../template-parts/Contact";
import Authentication from "../Authentication";
import "./Home.css";
import type { AppContextType } from "../../core/types";

const Home: React.FC = () => {
  const context = React.useContext(AppContext) as AppContextType;
  const { bgHook, details } = context;
  
  if (!details) {
    return <></>;
  }
  
  const { businessLineDetails, campaignDetails } = details;
  bgHook.setDynamicPage();

  let authenticationComponent = <Authentication />;

  return (
    <React.Fragment>
      <div className="container pt-3 pl-0 pr-0 home-element">
        <div className="row mt-5 mb-2 m-right-sm">
          <div className="offset-md-6 col-md-6 mt-5 pr-0 pt-1">
            {authenticationComponent}
          </div>
        </div>
      </div>
      <div className="container m-bottom-sm pl-md-0 pr-md-0">
        <div className="row m-bottom-sm">
          <Contact
            businessLineDetails={businessLineDetails}
            campaignDetails={campaignDetails}
          />
        </div>
        <div className="row mb-5 d-none d-md-block">
          <div className="col-12 mb-5">
            <br />
            <br />
            <br />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Home;
